import { render, staticRenderFns } from "./FollowUpUrl.vue?vue&type=template&id=7d363c02&scoped=true"
import script from "./FollowUpUrl.vue?vue&type=script&lang=js"
export * from "./FollowUpUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d363c02",
  null
  
)

export default component.exports